import _ from 'lodash';

import BaseModel from '@/models/BaseModel';
import PostContentModel from '@/models/PostContentModel';
import PostService from '@/services/PostService';

import Collection from '@/collection';

import moment from 'moment';

class PostModel extends BaseModel {
  // eslint-disable-next-line
  get defaults() {
    const baseDefaults = super.defaults;
    const defaults = {
      id: null,

      categories: [],

      created_at: moment().format('YYYY-MM-DD'),

      created_by: null,

      featured: false,

      language: 'de',

      main_category: null,

      meta_info: {},

      publish_at: moment().format('YYYY-MM-DD'),

      slug: {
        slug: null,
      },

      status: 'draft',

      step_count: 1,

      type: 'single',

      post_content: [],
    };

    return _.extend(baseDefaults, defaults);
  }

  constructor(props) {
    super(props);

    const collection = new Collection(
      props && props.post_content && props.post_content.length
        ? props.post_content
        : [new PostContentModel()],
      PostContentModel,
    );
    this.post_content = collection.list;
    delete this.posts;
  }

  addStep() {
    this.stepCount += 1;
    this.post_content.push(new PostContentModel({
      step: this.stepCount,
    }));
  }

  removeStep(number) {
    this.post_content.splice(number, 1);
  }

  getStep(number) {
    return this.post_content &&
      this.post_content.length &&
      this.post_content[number]
      ? this.post_content[number]
      : null;
  }

  save() {
    return new Promise((resolve, reject) => {
      if (this.id) {
        PostService.update(this.id, this)
          .then((response) => {
            this.assign(response);
            return resolve();
          })
          .catch(err => reject(err));
      } else {
        PostService.create(this)
          .then((response) => {
            this.assign(response);
            return resolve();
          })
          .catch(err => reject(err));
      }
    });
  }

  destroy() {
    if (this.id) {
      PostService.delete(this.id);
    }
  }
}

export default PostModel;
